export enum HomeTheme {
  Simple = 'simple',
  Basic_owl = 'basic_owl',
  Winter_owl = 'winter_owl',
  Desert_owl = 'desert_owl',
}
